export var StackPattern;
(function (StackPattern) {
    StackPattern[StackPattern["pan"] = 0] = "pan";
    StackPattern[StackPattern["move"] = 1] = "move";
})(StackPattern || (StackPattern = {}));
;
export default class PaintStack {
    constructor(onStackChange) {
        this._stack = [];
        this.pattern = StackPattern.pan;
        this._onStackChange = onStackChange;
    }
    getLast() {
        return this._stack.length == 0 ? undefined : this._stack[this._stack.length - 1];
    }
    add(path) {
        if (path) {
            this._stack.push(path);
            this._onStackChange(this._stack);
        }
    }
    removeLast() {
        this._stack.pop();
        this._onStackChange(this._stack);
    }
    join(path, tolerance) {
        path.simplify(60);
        if (this._stack.length == 0) {
            path.adjustClosed(tolerance);
            this._stack.push(path);
            this._onStackChange(this._stack);
        }
        else {
            const last = this.getLast();
            if (last) {
                path = last.join(path, tolerance);
                if (path.segments.length > last.segments.length) {
                    this._stack.push(path);
                    this._onStackChange(this._stack);
                }
            }
        }
        this.pattern = path.closed ? StackPattern.move : StackPattern.pan;
    }
    revoke() {
        if (this._stack.length > 0) {
            this._stack.pop();
            this._onStackChange(this._stack);
            const last = this.getLast();
            if (last)
                this.pattern = last.closed ? StackPattern.move : StackPattern.pan;
            else
                this.pattern = StackPattern.pan;
        }
    }
}
//# sourceMappingURL=paint_stack.js.map